
const backButton = '<span class="slick-prev-custom slick-arrow-custom slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"> <path d="M14.1666 19.8108L23.5 10.3108C24.1666 9.64412 25.1666 9.64412 25.8333 10.3108C26.5 10.9775 26.5 11.9775 25.8333 12.6441L17.6666 20.8108L25.8333 28.9775C26.1666 29.3108 26.3333 29.6441 26.3333 30.1441C26.3333 31.1441 25.6666 31.8108 24.6666 31.8108C24.1666 31.8108 23.8333 31.6441 23.5 31.3108L14 21.8108C13.5 21.4775 13.5 20.4775 14.1666 19.8108Z" fill="white"/> </svg></span>'
const nextButton = '<span class="slick-next-custom slick-arrow-custom slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"> <path d="M26.5598 19.8108L17.2265 10.3108C16.5598 9.64412 15.5598 9.64412 14.8931 10.3108C14.2265 10.9775 14.2265 11.9775 14.8931 12.6441L23.0598 20.8108L14.8931 28.9775C14.5598 29.3108 14.3931 29.6441 14.3931 30.1441C14.3931 31.1441 15.0598 31.8108 16.0598 31.8108C16.5598 31.8108 16.8931 31.6441 17.2265 31.3108L26.7265 21.8108C27.2265 21.4775 27.2265 20.4775 26.5598 19.8108Z" fill="white"/> </svg></span>'

$(document).ready(function() {
   $('.side-image .grid-flex').slick({
        slidesToShow: 3, // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: false, // Enable dots below the slider
        arrows: false, // Enable navigation arrows
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              autoplay:true
            }
          }
        ]
    });
  if($('.gallery-slider').length > 0){
    console.log($('.gallery-slider').data('scroll'))
    if($('.gallery-slider').data('scroll')){
   var args=  {
        infinite: true,
        slidesToShow:  $('.gallery-slider').data('slides'), // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: true, // Enable dots below the slider
     autoplay: $('.gallery-slider').data('scroll'),
        speed: 5000,
         autoplaySpeed: 0, 
          cssEase: 'linear',
        arrows: true, // Enable navigation arrows
     centerMode: true,
     centerPadding: '100px',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:  $('.gallery-slider').data('slides'),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:  $('.gallery-slider').data('slides'),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
               
            }
          }
        ]
    }
   }else{
       var args=  {
        infinite: true,
        slidesToShow:  $('.gallery-slider').data('slides'), // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: true, // Enable dots below the slider
     autoplay: $('.gallery-slider').data('scroll'),
        arrows: true, // Enable navigation arrows
     centerMode: true,
     centerPadding: '100px',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:  $('.gallery-slider').data('slides'),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:  $('.gallery-slider').data('slides'),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
               
            }
          }
        ]
    }
   }
    console.log(args)
   $('.gallery-slider').slick(
      args
    );
  }
  if($('.collection-slider').length > 0){ 
   $('.collection-slider').slick({
        infinite: true,
        slidesToShow: 1, // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: true, // Enable dots below the slider
        arrows: false, // Enable navigation arrows
     centerMode: true,
     centerPadding: '450px',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
               
            }
          }
        ]
    });
  }
   if($('.result_review_slider').length > 0){
   $('.result_review_slider').slick({
        slidesToShow: 1, // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: false, // Enable dots below the slider
        arrows: false, // Enable navigation arrows
      adaptiveHeight: true,
       asNavFor: '.logo-slider'
    });
      $('.logo-slider').slick({
        slidesToShow: 4, // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: false, // Enable dots below the slider
        arrows: false, // Enable navigation arrows
         asNavFor: '.result_review_slider',
         focusOnSelect: true,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
                centerMode: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
                centerMode: true,
               
            }
          }
        ]
    });
  }
    $('.product-slider ul.mega-dropdown__container').slick({
        infinite: true,
        slidesToShow: 5, // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll at a time
        dots: false, // Enable dots below the slider
        arrows: true, // Enable navigation arrows
        prevArrow: backButton,
       nextArrow: nextButton,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
               
            }
          }
        ]
    });
});




$(document).ready(function() {
  $('.store-availability-container-outer').on('click', function() {
    // Toggle visibility of the sibling .store-availability-information__stores.rte element
   $(this).find('.store-availability-information__stores.rte').toggle();

    // Rotate the drop-down icon
    $(this).find('.drop-down-btn svg').toggleClass('rotate');

    // Debugging log
    console.log('Store info toggled');
  });

  $('.product-detail-accordion.hide.small-down--show.content-columns').on('click', function(){
     $(this).find('.drop-down-btn svg').toggleClass('rot');
  })
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});
});





function showShopPayButton() {
    const walletButton = document.querySelector('shop-pay-wallet-button');

    if (walletButton) {
      // Remove any inline style that hides the button
      walletButton.removeAttribute('style');
      
      // Explicitly set the display property to block (with !important to override any CSS rule)
      walletButton.style.setProperty('display', 'block', 'important');
      

      console.log('Shop Pay button is now visible.');
    }
  }

  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(() => {
    showShopPayButton(); // Call function to ensure the button is shown
  });

  // Start observing the entire document for child list changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Ensure the page is fully loaded before running the script
  window.addEventListener('load', function() {
    // Initial call to show the button
    showShopPayButton();
  });
  // Ensure the page is fully loaded before running the script
  window.addEventListener('load', function() {
    // Call the function to attempt to show the button
    showShopPayButton();
  });


$(document).ready(function() {
  // Click event for the accordion header
  $('.accordion-header').on('click', function() {
    // Toggle the display of the accordion content
    $(this).next('.accordion-content').slideToggle(300);
    
    // Toggle the active class to rotate the icon
    $(this).toggleClass('active');
    
    // Optionally, you can log to the console to verify the toggle action
    console.log('Accordion toggled');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('.custom-toggle-button');
  const additionalContent = document.querySelector('.additional-content');

  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      if (additionalContent.style.display === 'none' || additionalContent.style.display === '') {
        additionalContent.style.display = 'block';
        toggleButton.textContent = 'Learn More -';
      } else {
        additionalContent.style.display = 'none';
        toggleButton.textContent = 'Learn More +';
      }
    });
  }
});



var ur = window.location.href;
if(ur.includes('/product')){

var inss = 0; var timerinss = setInterval(function(){
  if($('[name="properties[Installation]"]').length && $('div#infiniteoptions-container [type="checkbox"]').length > 1) {
   $('div#infiniteoptions-container fieldset label').addClass('hidden');
      
clearInterval(timerinss);}if( inss > 200){clearInterval(timerinss);}inss++;}, 50);

setInterval(function(){ 
       
if($('[name="properties[Installation]"]').length && $('div#infiniteoptions-container [type="checkbox"]').length > 1){
    
  
var ind = ($('.opt-btn:checked+.opt-label').index() - 1) / 2;
$('div#infiniteoptions-container .hidden [type="checkbox"]:checked').click(); 
$('div#infiniteoptions-container fieldset label').addClass('hidden');    

$('div#infiniteoptions-container [type="checkbox"]').eq(ind).parent().removeClass('hidden');   
}
       }, 100);  
}



var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){
//jQuery('.product-detail__detail > form').eq(0).before(jQuery('div#spiceaddonsappid')) 
    var ur = window.location.href;
if(ur.includes('titan')){
  var sdff = 0; var timersdff = setInterval(function(){
  if(jQuery('.sg-pro-access-heading').length) {
	 jQuery('.sg-pro-access-heading').html('Add-ons')
clearInterval(timersdff);}if( sdff > 200){clearInterval(timersdff);}sdff++;}, 50);
 
}
});
 
}



var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function() {
  var productMetafield = jQuery("#product-data").attr("data-metafield");

  if (productMetafield && productMetafield.length) {
    var productSku = productMetafield;

    jQuery(".template-product .prdct_right_txt a").attr("href", "https://design.backyardadventures.com/?set=" + productSku);

    var newHref = jQuery(".template-product .prdct_right_txt a").attr("href");

    jQuery(".left_frame>a").attr("href", newHref);
  }

  var initialVariantMetafield = jQuery(".opt-btn:checked + .opt-label").attr("data-sku");

  if (initialVariantMetafield && initialVariantMetafield.length) {
    var variantSku = initialVariantMetafield;
    var updatedHref = "https://design.backyardadventures.com/?set=" + variantSku;

    jQuery(".template-product .prdct_right_txt a").attr("href", updatedHref);
    jQuery(".left_frame > a").attr("href", updatedHref);
  }

  jQuery(document).on("change", ".opt-btn", function () {
    var variantMetafield = jQuery(".opt-btn:checked + .opt-label").attr("data-sku");

    if (variantMetafield && variantMetafield.length) {
      var variantSku = variantMetafield;
      var updatedHref = "https://design.backyardadventures.com/?set=" + variantSku;

      jQuery(".template-product .prdct_right_txt a").attr("href", updatedHref);
      jQuery(".left_frame > a").attr("href", updatedHref);
    }
  });

    jQuery(".template-product .prdct_right_txt a").attr("target", "_blank");
      jQuery(".left_frame > a").attr("target", "_blank");
}); 
}